import React from "react";
import { Button, Grid, GridColumn } from "@sumprio/ui";
import { AddIcon } from "@sumprio/ui/icons";
import EmptyStateIconSlot from "./EmptyState/EmptyStateIconSlot";
import EmptyStateContent from "./EmptyState/EmptyStateContent";

export interface ListEmptyViewAction {
  label: string;
  onClick: () => void;
}

export interface ListEmptyViewProps {
  title: string;
  description: string;
  primaryAction?: ListEmptyViewAction | null;
  secondaryAction?: ListEmptyViewAction | null;
}

export default function ListEmptyView({
  title,
  description,
  primaryAction,
  secondaryAction,
}: ListEmptyViewProps) {
  const hasPrimary = primaryAction?.label && primaryAction?.onClick;
  const hasSecondary = secondaryAction?.label && secondaryAction?.onClick;

  return (
    <Grid
      padding="xl"
      margin="lg"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="60vh"
      gap="md"
    >
      <GridColumn span={12} display="flex" justifyContent="center">
        <EmptyStateIconSlot />
      </GridColumn>
      <GridColumn span={12} display="flex" flexDirection="column" alignItems="center" gap="sm">
        <EmptyStateContent title={title} description={description} />
      </GridColumn>
      {(hasPrimary || hasSecondary) && (
        <GridColumn span={12} display="flex" justifyContent="center" gap="md">
          {hasSecondary && (
            <Button
              size="sm"
              variant="brand-secondaryGrey"
              onClick={secondaryAction!.onClick}
              icon={undefined}
            >
              {secondaryAction!.label}
            </Button>
          )}
          {hasPrimary && (
            <Button
              size="sm"
              type="brand"
              variant="brand-default"
              icon={AddIcon}
              onClick={primaryAction!.onClick}
            >
              {primaryAction!.label}
            </Button>
          )}
        </GridColumn>
      )}
    </Grid>
  );
}
